var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('strong',[_vm._v("OptomNoutbuk.UZ - ")]),_vm._v(" Все права защищены. Услуги лицензированы. ©OptomNoutbuk.Uz 2013 - "+_vm._s(new
            Date().getFullYear())+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }